<template>
  <main id='Default' v-if='kirby.page.template=="default"'>
    <!-- Article -->
    <article v-if='kirby.page.content && "builder" in kirby.page.content'>
      <!-- Sections -->
      <section v-for='(section, sectionindex) in kirby.page.content.builder.builder' :key='sectionindex'>
        <!-- Columns -->
        <div v-for='(column, columnindex) in section.columns' :style='{width: columnWidth(column.width)+"%"}' :key='columnindex'>
          <!-- Blocks -->
          <template v-for="(block, blockindex) in column.blocks">

            <!-- Heading -->
            <heading v-if='block.type=="heading"'
                     :key='blockindex'
                     :level='block.content.level'
                     :text='block.content.text' />

            <!-- Text -->
            <div v-if='block.type=="text"'
                 :key='blockindex'
                 v-html='block.content.text' />

           <!-- Text -->
           <hr v-if='block.type=="ruler"' :key='blockindex' />

            <!-- Figure -->
            <figure v-if='block.type=="image"' :key='blockindex'>
              <srcset :file="fileByUuid(kirby.page.files, block.content.image[0])" sizes="60rem"/>
            </figure>

            <!-- Button -->
            <button v-if='block.type=="link-button"'
                    :key='blockindex'
                    @click='goTo(block.content.target)'
                    :class='[ (block.content.fullwidth == "true") ? "fullwidth" : "" , block.content.alignment ]'
                    v-html='block.content.caption'/>
            </button>

            <!-- List -->
            <div v-if='block.type=="list"' :key='blockindex' v-html='block.content.text' />

            <!-- Figure -->
            <gallery v-if='block.type=="gallery"'
                     :key='blockindex'
                     :fileuuids='block.content.images'
                     :files='kirby.page.files'
                     :sizes='columnWidth(column.width)+"vw"' />

            <!-- Quote -->
            <blockquote v-if='block.type=="quote"' v-html='block.content.text' :key='blockindex' />

            <!-- Guides -->
            <guides v-if='block.type=="guides"' :block='block' :key='blockindex'/>

          </template>
          <!-- Blocks End -->
        </div>
        <!-- Columns End -->
      </section>
      <!-- Sections -->
    </article>
    <!-- 404 -->
    <article class='error' v-if='!kirby.page.strings'>
      <h2 v-if='kirby.pages.error' v-html='kirby.pages.error.strings.title' />
      <a v-if='kirby.pages.error' class='button' href='/' v-html='"Return to home page"' />
    </article>
    <!-- Footer -->
    <MainFooter />
  </main>
  <main v-else-if='kirby.page.template=="form"'>
    <iframe v-once :src='kirby.page.strings.url' allowtransparency="true" allowfullscreen="true" allow="geolocation; microphone; camera" width="100%" height="100%"/>
  </main>
</template>

<style scoped>

  main {
    padding-top: 6em;
  }

  article {
    padding: var(--main-padding);
    max-width: var(--main-max-width);
    box-sizing: border-box;
    margin: auto;
  }

  section {
    width: 100%;
    display: flex;
    flex-direction: var(--columns-or-rows);
    gap: 4em;
    padding-top: 1em;
    padding-bottom: 1em;
  }

  figure {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    width: 100%;
  }

  figure img {
    box-sizing: border-box;
    width: 100%;
  }

  hr {
    max-width: var(--main-max-width);
    border: none;
    border-top: var(--thinline);
    outline: none;
  }

  button {
    font-family: inherit;
    display: block;
    margin-top: 2em;
    margin-bottom: 2em;
    padding: 1.5em 3em;
    border-radius: 3em;
  }

  button.fullwidth {
    width: 100%;
  }

  button.center {
    margin-left:  auto;
    margin-right:  auto;
  }

  article.error {
    padding: 8em;
    text-align: center;
  }

  article.error a.button {
    margin: 0;
  }

  iframe {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    outline: none;
    border: none;
  }
</style>

<style>
  #Default h1, #Default h2 {
    font-size: 3rem;
    column-span: all;
    font-weight: normal;
  }

  #Default ul {
    display: inline-block;
    width: 100%;
    margin-left: 0;
    padding-left: 0.5em;
  }
</style>

<script>
import mixins from '.././mixins.js'
export default {
  mixins: [mixins],
  methods: {
    columnWidth: function(width) {
      return (window.innerWidth > 800) ? parseInt(100 * eval(width)) : 100;
    },
    goTo: function(url){
      if(url)  window.open(url, '_blank').focus();
    }
  }
}
</script>
